<template>
	<div>
		<Tabs :tab="tab" @checkTab="checkTab"></Tabs>
		
		<router-view :type="type" :is="tab" :clearData="clearData" :formData="formData" :reportCode="reportCode" @stopQuery="$emit('stopQuery')" @checkTab="checkTab"></router-view>
	</div>
</template>

<script>
	const Tabs = () => import('./Tabs');
	const Personal = () => import('./Personal');
	const Questions = () => import('./Questions');
	const Bodily = () => import('./Bodily');
	const Biochemical = () => import('./Biochemical');
	
	export default{
		name: 'dataTemplate',
		data() {
			return {
				tab: 'Personal' ,//默认从个人信息开始填写
				
			}
		},
		components: {
			Tabs,
			Personal,
			Questions,
			Bodily,
			Biochemical
		},
		props: [ 'type', 'formData', 'reportCode', 'clearData' ],
		methods: {
			//切换tab 参数 tab组件名
			checkTab(tab) {
				this.tab = tab;
			}
		}
	}
</script>

<style>
</style>
